import http from '../config'
const auth = {
}
export default auth
